export default __webpack_public_path__ + "f9d47d3ce583fae8267b9091f25e0371.svg";